module.exports = __webpack_public_path__ + "images/feature/calendar-todo-0-01bc3f9ccb38b3b7bed97491ff67c20a.gif";